import http from "./http";

class MotsClesService {
    index(token){
        return http.get("/api/motscles",{ headers: { 'Authorization': 'Bearer '+token } })
    }

    store(data,token){
        return http.post("/api/motscles/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/motscles/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/motscles/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/motscles/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/motscles/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new MotsClesService()